import { render, staticRenderFns } from "./FormatForm.vue?vue&type=template&id=36707ff4&"
import script from "./FormatForm.vue?vue&type=script&lang=js&"
export * from "./FormatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports